@if (!ready || (ready && (sortedAccountItems?.length || inviteItems?.length))) {
  <se-fe-card>
    <se-fe-card-header seFeDataTitle="Permissions" seFeDataHeavyBorder="true" [seFeDataSubtitle]="subtitle">
      <div seFeCardHeaderActions>
        @if (ready && (useAddParentModal || canManageProfile) && !isSelf) {
          <se-fe-button
            (click)="openAddModal()"
            [seFeDataIsDisabled]="disableGrant()"
            [seFeTooltipTrigger]="disableGrant() ? parentAddTooltip : null"
            [ngClass]="{'disabled': disableGrant()}">
            <se-fe-icon seFeDataName="plus" seFeDataSize="500" seFeDataColor="primary"></se-fe-icon>
            <span style="color: #00668f;"> Add</span>
          </se-fe-button>
        }
        <se-fe-tooltip #parentAddTooltip>
          @if (hasMetGuardianLimit) {
            <span>
              {{ profile.persona.first_name }} has reached the limit for guardianship access. You can manage access from the permissions card.
            </span>
          }
          @if (!hasMetGuardianLimit) {
            <span>
              {{ profile.user?.self_persona?.first_name }} cannot be granted access to any additional members of your household
            </span>
          }
        </se-fe-tooltip>
      </div>
    </se-fe-card-header>
    @if (!ready) {
      <se-fe-card-content>
        <se-fe-spinner
          [seFeDataSize]="900"
          [seFeDataInverted]="false"
          [seFeDataCenter]="true">
        </se-fe-spinner>
      </se-fe-card-content>
    }
    @if (ready) {
      <se-fe-card-content>
        <se-fe-list class="guardian-list">
          @for (accountItem of sortedAccountItems; track accountItem) {
            <se-fe-list-item>
              <ng-container *ngTemplateOutlet="guardianListItem; context: { listItem: accountItem }"></ng-container>
            </se-fe-list-item>
          }
          @for (inviteItem of inviteItems; track inviteItem) {
            <se-fe-list-item>
              <ng-container *ngTemplateOutlet="guardianListItem; context: { listItem: inviteItem }"></ng-container>
            </se-fe-list-item>
          }
        </se-fe-list>
      </se-fe-card-content>
    }
  </se-fe-card>
}
<se-fe-toast></se-fe-toast>

<ng-template #guardianListItem let-listItem="listItem">
  <se-fe-header [seFeDataTitle]="listItem.title" [seFeDataSubtitle]="(!listItem.pending || isGuardian) && listItem.subtitle" seFeDataSize="600">
    <se-fe-avatar seFeHeaderVisual
      seFeDataType="persona"
      [seFeDataIdentity]="listItem.identity"
      [seFeDataImgUrl]="listItem.imgUrl"
      seFeDataSize="300">
    </se-fe-avatar>
    @if (!(listItem.pending || listItem.accessOptions)) {
      <se-fe-chip
      seFeHeaderTitleExtra [seFeDataText]="listItem.access | titlecase"></se-fe-chip>
    }
    @if (listItem.pending) {
      <div seFeHeaderTitleExtra>
        <se-fe-chip seFeDataText="Pending" [seFeMenuTrigger]="listItem.menuOptions ? itemMenu : null">
          {{ isGuardian ? listItem.email : listItem.subtitle }}
        </se-fe-chip>
        <se-fe-menu #itemMenu [seFeDataOptions]="listItem.menuOptions"></se-fe-menu>
      </div>
    }
    @if (!listItem.pending && listItem.menuOptions && listItem.accessOptions && !(isSelf && listItem.access === 'owner')) {
      <div seFeHeaderTitleExtra
        >
        <se-fe-chip [seFeDataText]="listItem.access | titlecase" [seFeMenuTrigger]="accessMenu"></se-fe-chip>
        <se-fe-menu #accessMenu [seFeDataOptions]="listItem.accessOptions"></se-fe-menu>
      </div>
    }
    @if (listItem.menuOptions && !listItem.pending) {
      <ng-container seFeHeaderActions>
        @if (!listItem.pending) {
          <se-fe-icon-button
            [seFeMenuTrigger]="itemMenu"
            seFeDataEmphasis="low"
            [seFeDataSnug]="true">
            <se-fe-icon seFeDataName="more" seFeDataSize="700"></se-fe-icon>
          </se-fe-icon-button>
        }
        <se-fe-menu #itemMenu [seFeDataOptions]="listItem.menuOptions"></se-fe-menu>
      </ng-container>
    }
  </se-fe-header>
</ng-template>

<se-fe-modal #removeConfirmModal [seFeDataActions]="removeConfirmButtons">
  @if (guardianToRemove) {
    <se-fe-modal-content>
      <se-fe-header seFeDataTitle="Remove Access?" [seFeDataLevel]="3" seFeDataSize="500">
      </se-fe-header>
      <div class="modal-item">You are about to remove:</div>
      <div class="modal-item">
        <se-po-persona-avatar
          [headerSubtitle]="guardianToRemove.user?.email_address.address || guardianToRemove.persona.email_addresses[0].address"
          [persona]="guardianToRemove.user?.self_persona">
        </se-po-persona-avatar>
      </div>
      <div class="modal-item">This will revoke all access that {{ guardianToRemove.user?.self_persona.full_name || guardianToRemove.persona?.full_name }} has to {{ accessModifySubject.persona?.first_name || accessModifySubject.user?.self_persona.first_name }}'s profile.</div>
    </se-fe-modal-content>
  }
</se-fe-modal>
<se-fe-modal #downgradeConfirmModal [seFeDataActions]="downgradeConfirmButtons">
  @if (accessModifySubject) {
    <se-fe-modal-content>
      <se-fe-header seFeDataTitle="Are you sure you want to change your access?" [seFeDataLevel]="3" seFeDataSize="500">
      </se-fe-header>
      <div class="modal-item">You are about to change your access from a manager to a viewer for:</div>
      <div class="modal-item">
        <se-po-persona-avatar
          [persona]="accessModifySubject.user?.self_persona || accessModifySubject.persona">
        </se-po-persona-avatar>
      </div>
      <div class="modal-item">
        To change your access back to a manager, you will need to reach out to the account owner for {{ (accessModifySubject.user?.self_persona || accessModifySubject.persona)?.full_name }}.
      </div>
    </se-fe-modal-content>
  }
</se-fe-modal>
@if (useAddChildModal) {
  <se-po-child-grant-access-modal #addChildPermissionsModal [profile]="profile" [guardians]="guardians" [inviteItems]="inviteItems" (guardianAdded)="guardianAdded()"></se-po-child-grant-access-modal>
}
@if (useAddParentModal) {
  <se-po-parent-grant-access-modal #addParentPermissionsModal [profile]="profile" [profiles]="profiles" [accountItems]="sortedAccountItems" [guardians]="guardians" [allInvites]="allInvites" [inviteItems]="inviteItems" (guardianAdded)="guardianAdded()"></se-po-parent-grant-access-modal>
}
